import React, { createContext, useContext, useState, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { documentsAPI } from '../services/api';
import toast from 'react-hot-toast';

const UploadContext = createContext();

export const useUpload = () => useContext(UploadContext);

export function UploadProvider({ children }) {
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const queryClient = useQueryClient();

  const uploadFile = useCallback((file, maxFileSize) => {
    if (file.size > maxFileSize) {
      toast.error(`File ${file.name} is too large (max ${Math.round(maxFileSize / (1024 * 1024))}MB)`);
      return;
    }

    const uploadId = Date.now() + Math.random();
    setUploadingFiles(prev => [...prev, { id: uploadId, file, progress: 0 }]);

    documentsAPI.uploadDocument(file, false)
      .then(() => {
        queryClient.invalidateQueries('documents');
        toast.success(`${file.name} uploaded successfully!`);
      })
      .catch((error) => {
        toast.error(error.response?.data?.detail || `Upload failed: ${file.name}`);
      })
      .finally(() => {
        setUploadingFiles(prev => prev.filter(f => f.id !== uploadId));
      });
  }, [queryClient]);

  return (
    <UploadContext.Provider value={{ uploadingFiles, uploadFile }}>
      {children}
    </UploadContext.Provider>
  );
}
